export const user_zone_lang={
    TH:{
      header_card:"กำหนดข้อมูลโซนให้กับพนักงาน",
      header_table:"กำหนดข้อมูลโซนให้กับพนักงาน",
      user_id:"รหัสพนักงาน",
      user_name:"ชื่อพนักงาน",
      user_surname:"นามสกุล",
      flag:"สถานะของพนักงาน",
      information_zone:"ข้อมูลรายละเอียดโซน",
      confirm:"บันทึกข้อมูล",
      delete:"ลบข้อมูล",
      approve_detail:"คุณต้องการกำหนดโซนตามข้อมูลนี้ใช่ไหม ?",
      approve_title:"กรุณายืนยัน",
      approve_cancel:"ยกเลิก",
      phone_no:"เบอร์โทร",
      notapprove_detail:"คุณต้องการลบข้อมูลโซนของพนักงานใช่ไหม ?",
      inform_title:"ไม่สามารถบันทึกข้อมูลได้",
      inform_detail:"กรุณาเลือกข้อมูลโซนก่อนทำการบันทึก",
      inform_confirm:"ตกลง",
      approve_getdetail:"แสดงรายละเอียดโซน",
      header_select:"โซนที่เลือก",
      header_unselect:"โซนที่ไม่ได้เลือก",
      show_information_back:"ย้อนกลับ",
      zone_id:"รหัสโซน",
      zone_name:"โซน",
      all_select:"เลือกทั้งหมด",
      all_unselect:"ไม่เลือกทั้งหมด"
    },
    EN:{
      header_card:"Assign Zone to Users",
      header_table:"Assign Zone to Users Information",
      request_id:"Request Id",
      request_date:"Request Date",
      flag:"Status",
      remark:"Request Information",
      approve:"Approve",
      notapprove:"Not approve",
      approve_detail:"Do you need to Approve this request, right?",
      approve_title:"Confirm ?",
      approve_cancel:"Cancel",
      notapprove_detail:"Do you need to Not Approve this request, right?",
      inform_title:"Can't process this request.",
      inform_detail:"This request processed",
      inform_confirm:"Yes",
      approve_getdetail:"Show Information",
      show_information_back:"Back",
      user_id: "employee code",
      user_name:"first name",
      user_surname:"surname",
      phone_no:"phone number",
      delete:"delete",
      confirm:'save'

    }
  }
  